export const DEFAULT_PROGRAM_SETTINGS = {
  operation: {
    addition: false,
    subtraction: false,
    multiplication: false,
    division: false,
  },
  timerThreshold: null as string | null,
  difficultyLevel: null as string | null,
  programLength: null as string | null,
}

export const TIMER_THRESHOLDS = ['12', '6', '3', '2', '1.5'] as const
export const DIFFICULTY_LEVELS = ['beginning', 'regular', 'extended'] as const
export const DIFFICULTY_LEVELS_LABELS = {
  beginning: 'Beginning',
  regular: 'Regular',
  extended: 'Expanded',
}
export const PROGRAM_LENGTHS = {
  ongoing: 'Adaptive Practice',
  fluencyAssessment: 'Placement Quiz',
} as const

export const OPERATIONS = [
  'addition',
  'subtraction',
  'multiplication',
  'division',
] as const
